import { createElement, forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@skupreme/shared/ui';

type BlockProps = HTMLAttributes<HTMLElement>;

/* Plain `.ts` so the importers' `./styles` path stays put, hence createElement. */
function block(tag: 'div' | 'span', displayName: string, classes: string) {
  const Block = forwardRef<HTMLElement, BlockProps>(
    ({ className, ...rest }, ref) =>
      createElement(tag, { ...rest, ref, className: cn(classes, className) }),
  );
  Block.displayName = displayName;
  return Block;
}

export const AccordionTitleRow = block(
  'div',
  'AccordionTitleRow',
  'sk:flex sk:w-full sk:items-center',
);

export const AccordionBodyContainer = block(
  'div',
  'AccordionBodyContainer',
  'sk:flex sk:flex-col sk:gap-1 sk:py-1 sk:text-xs sk:text-fg',
);

export const BoldText = block('span', 'BoldText', 'sk:font-semibold');

type RowProps = HTMLAttributes<HTMLDivElement> & { disabled?: boolean };

export const Row = forwardRef<HTMLDivElement, RowProps>(
  ({ disabled, className, ...rest }, ref) =>
    createElement('div', {
      ...rest,
      ref,
      className: cn(
        'sk:flex sk:items-center sk:justify-between sk:gap-2',
        disabled ? 'sk:text-fg-tertiary' : 'sk:text-fg',
        className,
      ),
    }),
);
Row.displayName = 'Row';

export const SummaryTitleRow = block(
  'div',
  'SummaryTitleRow',
  'sk:border-y sk:border-solid sk:border-x-0 sk:border-border-subtle sk:py-1',
);

export const AddressValidationContainer = block(
  'div',
  'AddressValidationContainer',
  'sk:flex sk:cursor-pointer sk:items-center sk:justify-center sk:text-xs sk:leading-normal sk:text-danger sk:[&_span]:underline',
);
